export default {
  title: 'Exclusieve aanbiedingen',
  header: {
    back: 'Terug',
    title: 'Beloningen',
  },
  info: {
    title: 'U heeft {{points}} punten.',
    description:
      'Besteed {{amount}} om 5 punten te verdienen! Voeg artikelen gratis toe aan uw winkelwagen met uw gespaarde punten.',
  },
  rewards: {
    data: [
      {
        title: 'Punten verdienen bij elke bestelling',
        description: 'Voor elke {{amount}} die u uitgeeft, krijgt u 5 punten op uw account.',
      },
      {
        title: 'Punten verdienen bij elke bestelling',
        description:
          'Wissel uw punten in voor gratis cadeaus! Begin met sparen vanaf 350 punten, wat overeenkomt met het besteden van {{amount}}.',
      },
      {
        title: 'Punten verdienen bij elke bestelling',
        description: 'Ontdek exclusieve aanbiedingen, acties en kortingen. Bekijk ledenaanbiedingen in de app.',
      },
    ],
  },
};
